export const QUEST_LABS = {
  "t1-q8": {
    tool: "mock-meeting",
    title: "Mock Meeting Simulator",
    desc: "Step into the Chair's seat and run a full meeting — call to order, motions, vote, and adjourn.",
  },
  "t2-q1": {
    tool: "studio-docs",
    path: "/studio/docs",
    title: "Word Processing Skill Studio",
    desc: "12 guided, auto-graded missions — format real documents chunk by chunk and export to PDF.",
  },
  "t2-q2": {
    tool: "studio-sheets",
    path: "/studio/sheets",
    title: "Spreadsheets Skill Studio",
    desc: "11 guided, auto-graded missions — SUM, AVERAGE, COUNT, MAX, MIN, sorting, and charts.",
  },
  "t2-q4": {
    tool: "studio-slides",
    path: "/studio/slides",
    title: "Presentations Skill Studio",
    desc: "12 guided, auto-graded missions — layouts, the 5×5 rule, images, charts, animations, and delivery.",
  },
  "t3-q5": {
    tool: "phishing",
    title: "Phishing Spotter",
    desc: "Inspect real-looking emails and tap every phishing red flag you can find.",
  },
  "t3-q6": {
    tool: "cipher",
    title: "Cipher Playground",
    desc: "Encode and decode secret messages with Caesar, Substitution, and a Pigpen bonus.",
  },
};
